/// <amd-module name="SuiteCommerce.FeaturedCategory.Item.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Item.View", ["require", "exports", "Backbone", "SuiteCommerce.FeaturedCategory.Instrumentation", "SuiteCommerce.FeaturedCategory.Common.Utils", "SuiteCommerce.FeaturedCategory.Item.Configuration", "sc_featuredcategory_item.tpl"], function (require, exports, Backbone_1, Instrumentation_1, Utils_1, Item_Configuration_1, featuredCategoryItemTpl) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemView = void 0;
    var ItemView = /** @class */ (function (_super) {
        __extends(ItemView, _super);
        function ItemView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = featuredCategoryItemTpl;
            _this.colsPerRow = options.colsPerRow;
            _this.colsPerRowPhone = options.colsPerRowPhone;
            _this.showItemPrice = options.showItemPrice;
            _this.showItemName = options.showItemName;
            return _this;
        }

        ItemView.prototype.dateOrd =function (d) {
            if(d>3 && d<21) return d+'th';
            switch (d % 10) {
                case 1:  return d+"st";
                case 2:  return d+"nd";
                case 3:  return d+"rd";
                default: return d+"th";
            }
        }

        ItemView.prototype.dateFormatConversion = function(paramdate)
		{
            var newDateFormat =''
            if(paramdate)
            {
                var self = this;				
                var parts = paramdate.split('/');
                let date = new Date(parts[2], parts[1] - 1, parts[0]) 
                let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
                let month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
                let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);
                 newDateFormat = day+' ' +month +' '+year;  
            }
			return newDateFormat
		}

        ItemView.prototype.dateFormatConBadges = function(paramdate)
		{
            var eventstartDate= '';
            if(paramdate){
                var parts = paramdate.split('/');
                let date = new Date(parts[2], parts[1] - 1, parts[0])
                let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
                let month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
                let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);
                let newDateFormat = day+' ' +month;
                 eventstartDate =  newDateFormat;
            }
            return eventstartDate
        }

        ItemView.prototype.logQuickAddButton = function () {
            var quickAddButtonUsageLog = Instrumentation_1.default.getLog('quickAddButtonUsageLog');
            quickAddButtonUsageLog.setParameters({
                activity: 'Quick add button pressed',
            });
            quickAddButtonUsageLog.submit();
        };
        ItemView.prototype.getImageData = function () {
            var unavailableImgLink = 'img/no_image_available.jpeg';
            var itemImagesDetail = this.model.itemImagesDetail || {};
            itemImagesDetail = itemImagesDetail.media || itemImagesDetail;
            var images = Utils_1.Utils.imageFlatten(itemImagesDetail);
            return images.length ? images[0] : {
                url: Utils_1.Utils.getThemeAbsoluteUrlOfNonManagedResources(unavailableImgLink, Item_Configuration_1.ItemConfiguration.imageNotAvailable),
                altimagetext: Utils_1.Utils.translate('Image not available'),
            };
        };
        ItemView.prototype.getItemPrice = function () {
            if (Utils_1.Utils.hidePrices()) {
                return '';
            }
            var matrixDetail = this.model.matrixChildItemsDetail;
            if (matrixDetail && matrixDetail.length > 0) {
                var min = 0;
                var max = 0;
                var minFormatted = '';
                var maxFormatted = '';
                for (var i = 0; i < matrixDetail.length; i += 1) {
                    var priceDetail = matrixDetail[i].onlinecustomerprice_detail;
                    var price = priceDetail && (priceDetail.onlinecustomerprice || priceDetail.pricelevel1) || 0;
                    var priceFormatted = priceDetail && (priceDetail.onlinecustomerprice_formatted || priceDetail.pricelevel1_formatted) || '';
                    if (price > 0 && (price < min || min === 0)) {
                        min = price;
                        minFormatted = priceFormatted;
                    }
                    if (price > max) {
                        max = price;
                        maxFormatted = priceFormatted;
                    }
                }
                if (min > 0 && max > 0 && min !== max) {
                    return minFormatted + " " + Utils_1.Utils.translate('to') + " " + maxFormatted;
                }
            }
            var priceData = this.model.onlineCustomerPriceDetail;
            return priceData && priceData.onlinecustomerprice_formatted || this.model.priceLevel1Formatted || '';
        };
        ItemView.prototype.getContext = function () {
            var displayName = this.model.displayName;
            var imgData = this.getImageData();
            var itemPrice = this.getItemPrice();
            var itemLink = this.model.urlComponent ?
                "/" + this.model.urlComponent : "/product/" + this.model.internalId;

            var event_sdate = this.dateFormatConversion(this.model.get('custitem_nus_event_sdate'));
            var event_edate = this.dateFormatConversion(this.model.get('custitem_nus_eventedate'));
            var event_badges_sdate = this.dateFormatConBadges(this.model.get('custitem_nus_event_sdate'));
            var event_stime = this.model.get('custitem_event_stime');
            var eventetime = this.model.get('custitem_nus_eventetime');
            var ems_event_mode = this.model.get('custitem_nus_ems_event_mode');
            var ems_issupevent = this.model.get('custitem_nus_ems_issupevent');
            var pricelevel2 = this.model.get('pricelevel2_formatted');
            var pricelevel5 = this.model.get('pricelevel5_formatted');
            var custEventImage = this.model.get('custitem_nus_emsimage') || '';
            var equalDates;
            if(event_edate === event_sdate){
                equalDates = "start and end dates are equal";
            }
            return {
                displayName: displayName,
                itemPrice: itemPrice,
                itemLink: itemLink,
                renderItem: !!(displayName && imgData && imgData.url),
                imageUrl: imgData ? imgData.url : '',
                imageAlt: imgData ? imgData.altimagetext : '',
                colsPerRow: this.colsPerRow,
                colsPerRowPhone: this.colsPerRowPhone,
                showItemName: this.showItemName,
                showItemPrice: this.showItemPrice,
                event_sdate:event_sdate,
                event_edate:event_edate,
                equalDates: equalDates,
                event_badges_sdate:event_badges_sdate,
                event_stime: event_stime ? event_stime.toUpperCase() : '',
                eventetime:eventetime ? eventetime.toUpperCase() : '',
                ems_event_mode:ems_event_mode,
                ems_issupevent: ems_issupevent,
                pricelevel2: pricelevel2,
                custEventImage : custEventImage,
                pricelevel5 : pricelevel5
            };
        };
        return ItemView;
    }(Backbone_1.View));
    exports.ItemView = ItemView;
});
